module.exports = __webpack_public_path__ + "media/images/img-counsellor-cca8b99735dd11934c2aec8197e12702.svg";